p Javascript added here will be run once the flow is added to the document and before any steps are shown.
div.prehook-editor
    != model.prehook

textarea.hidden(name='prehook')
    != model.prehook
